// Note: The timeout only bounds how long the app waits for a reply - it does not cancel
// the SW work, which continues inside event.waitUntil(). Hence the split: a short wait is
// fine when the response is ignored. See docs/pwa.docs.md, "Why the timeouts differ".
export const SERVICE_WORKER_MESSAGE_TIMEOUT = 500;

// Note: pushManager.subscribe() round-trips to FCM/APNs, and we need its result to
// register the subscription with WebPushServer.
export const SERVICE_WORKER_SUBSCRIBE_TIMEOUT = 30_000;
